<template>
  <fragment>
    <hero-header page-name="" hero-title="introduction"/>
    <v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" sm="6" class="mb-10">
          <div class="mb-5" v-html="$t('pageAboutUs.intro')"></div>
        </v-col>
        <v-col cols="12" sm="6" class="mb-10">
          <video controls="controls" :poster="require('../assets/video_cover.jpg')" width="100%">
            <!--<source :src="require('../assets/video/TMX20200120_gopro_mp4.mp4')" type="video/mp4">
            <source :src="require('../assets/video/TMX20200120_gopro_webm.webm')" type="video/webm">-->
            Your browser does not support HTML5 video.
          </video>
          <!--v-img :src="require('../assets/placeholder_video.jpg')" aspect-ratio="1.7778" /-->
        </v-col>
        <v-col cols="12" class="mb-5">
          <h1 class="text-center">
            {{ $t('pageAboutUs.companyHistory') }}
          </h1>
        </v-col>
        <v-col cols="12" sm="6" class="mb-10">
          <div class="mb-5" v-html="$t('pageAboutUs.companyHistoryText')"></div>
        </v-col>
        <v-col cols="12" sm="6" class="mb-10">
          <carousel-small :pictures="historyPics" />
          <!--v-row>
            <v-col cols="6" md="3">
              <v-img :src="require('../assets/tmx-1.jpeg')" />
            </v-col>
            <v-col cols="6" md="3">
              <v-img :src="require('../assets/tmx-2.jpeg')" />
            </v-col>
            <v-col cols="6" md="3">
              <v-img :src="require('../assets/tmx-3.jpeg')" />
            </v-col>
            <v-col cols="6" md="3">
              <v-img :src="require('../assets/tmx-4.jpeg')" />
            </v-col>
          </v-row-->
        </v-col>
        <v-col cols="12" class="mb-5">
          <h1 class="text-center">
            {{ $t('pageAboutUs.whereAreWeNow') }}
          </h1>
        </v-col>
        <v-col cols="12" class="mb-10">
          <v-row>
            <v-col cols="12" sm="5">
              <v-row>
                <v-col cols="12">
                  <v-img :src="require('../assets/placeholder_4.jpg')" />
                </v-col>
                <v-col cols="6">
                  <v-img :src="require('../assets/placeholder_5.jpg')" />
                </v-col>
                <v-col cols="6">
                  <v-img :src="require('../assets/tmx_warehouse2.jpg')" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="7">
              <div class="mb-5" v-html="$t('pageAboutUs.whereAreWeNowText')"></div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mb-5">
          <h1 class="text-center">
            {{ $t('pageAboutUs.ourFuture') }}
          </h1>
        </v-col>
        <v-col cols="12" class="mb-10">
          <div class="mb-5" v-html="$t('pageAboutUs.ourFutureText')"></div>
          <v-row>
            <v-col cols="6" md="4">
              <v-img :src="require('../assets/placeholder_6.jpg')" aspect-ratio="1" max-height="280" />
            </v-col>
            <v-col cols="6" md="4">
              <v-img :src="require('../assets/tmx_future.jpg')" aspect-ratio="1" max-height="280" position="center center" />
            </v-col>
            <v-col cols="6" md="4">
              <v-img :src="require('../assets/tmx_future_network.jpg')" aspect-ratio="1" max-height="280" position="center center" />
            </v-col>
          </v-row>
        </v-col>
        <!--v-col cols="12" class="mb-5">
          <h1 class="text-center">
            Vezetőink
          </h1>
        </v-col>
        <v-col cols="12" class="mb-10">
          <div class="mb-5">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sed tristique massa, quis tempor tortor. Phasellus a maximus sem, sit amet rhoncus diam. Suspendisse vulputate bibendum enim, vel elementum sapien posuere quis. Duis aliquam nibh felis, eget scelerisque elit molestie vitae. Vivamus eget placerat ligula. Nunc id odio ullamcorper, iaculis turpis ut, volutpat nunc. Fusce quis lobortis ligula. In in enim in augue ultrices vehicula non vel urna. Nunc nec erat at eros cursus condimentum. Donec tellus tellus, interdum non euismod nec, lobortis sit amet dui. Fusce a augue iaculis, ultricies sapien at, sagittis sapien. Fusce bibendum arcu in lectus ullamcorper, malesuada hendrerit quam mollis. Nulla id urna placerat nunc pellentesque mollis.
          </div>
          <v-row>
            <v-col cols="6" md="2">
              <v-img :src="require('../assets/man_placeholder_7.jpg')" />
            </v-col>
            <v-col cols="6" md="2">
              <v-img :src="require('../assets/woman_placeholder_10.jpg')" />
            </v-col>
            <v-col cols="6" md="2">
              <v-img :src="require('../assets/man_placeholder_8.jpg')" />
            </v-col>
            <v-col cols="6" md="2">
              <v-img :src="require('../assets/woman_placeholder_11.jpg')" />
            </v-col>
            <v-col cols="6" md="2">
              <v-img :src="require('../assets/man_placeholder_9.jpg')" />
            </v-col>
            <v-col cols="6" md="2">
              <v-img :src="require('../assets/woman_placeholder_12.jpg')" />
            </v-col>
          </v-row>
        </v-col-->
        <v-col cols="12" class="mb-5">
          <h1 class="text-center">
            {{ $t('pageAboutUs.moreEmployees') }}
          </h1>
        </v-col>
        <v-col cols="12" class="mb-10">
          <v-row>
            <v-col cols="12" sm="7">
              <div class="mb-5" v-html="$t('pageAboutUs.moreEmployeesText')"></div>
            </v-col>
            <v-col cols="12" sm="5">
              <v-row>
                <v-col cols="12">
                  <v-img :src="require('../assets/tmx_350_munkatars.jpg')" aspect-ratio="1.777"/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <!--v-col cols="12" class="mb-10">
          <div>
            Magyarország vezető telekommunikációs szervízeként több mint 350 munkatársunkért tartozunk felelősséggel. Mindig olyan kollégákat keresünk, akik szakterületükön kiemelkedő teljesítményt képesek nyújtani, megbízhatóak, lojálisak, lendületesek és elhivatottak. Cserébe stabil, hosszútávra szóló lehetőséget, színvonalas munkakörnyezetet és folyamatos szakmai továbbképzést biztosítunk számukra.
          </div>
        </v-col-->
        <!-- BÜSZKESÉG SECTION START -->
        <v-col cols="12">
          <v-row>
            <v-col cols="12" class="mb-10">
              <h1 class="text-center">
                {{ $t('pageAboutUs.whatWeAreProudOf') }}
              </h1>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-for="(item, index) in proud" :key="index">
              <v-row justify="center" :class="$vuetify.breakpoint.smAndDown ? 'px-3 mb-10' : 'px-8 mb-10'" style="height: 100%;">
                <service-box v-bind:service="item" :show-desc="true" :show-button="true"/>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <!-- BÜSZKESÉG SECTION END -->
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import serviceBox from '../components/serviceBox.vue';
import carouselSmall from '../components/carouselSmall.vue';

export default {
  name: 'about-us',
  components: {
    heroHeader, serviceBox, carouselSmall,
  },
  data() {
    return {
      proud: [
        {
          id: 's8920472',
          img: 'javitas_kep4',
          title: 'ISO 27001:2013',
          desc: 'proudBox.ISO27001Desc',
          button: {
            path: 'doc/HU18764-19_ISO-IEC_27001-2013.pdf',
            text: 'button.view',
          },
        },
        {
          id: 's329j5653',
          img: 'javitas_kep4',
          title: 'ISO 9001:2015',
          desc: 'proudBox.ISO9001Desc',
          button: {
            path: 'doc/TMX_QMS_2019_main_cert_HU.pdf',
            text: 'button.view',
          },
        },
        {
          id: 's329j353',
          img: 'javitas_kep4',
          title: 'ISO 14001:2015',
          desc: 'proudBox.ISO14001Desc',
          button: {
            path: 'doc/TMX_EMS_2019_main_cert_HU.pdf',
            text: 'button.view',
          },
        },
        {
          id: 's329j33',
          img: 'halozat_kep3',
          title: 'proudBox.bloodDonation',
          desc: 'proudBox.bloodDonationDesc',
          button: {
            path: null,
            text: null,
          },
        },
        {
          id: 's3292j3',
          img: 'logisztika_kep1',
          title: 'proudBox.wasteSorting',
          desc: 'proudBox.wasteSortingDesc',
          button: {
            path: null,
            text: null,
          },
        },
        {
          id: 's3292j3',
          img: 'presales_kep2',
          title: 'proudBox.qualityAndEnvironmentalPolicy',
          desc: 'proudBox.qualityAndEnvironmentalPolicyDesc',
          button: {
            path: 'doc/TMXMinosegeskornyezetpolitikainyilatkozat.pdf',
            text: 'button.view',
          },
        },
      ],
      historyPics: [
        {
          src: 'tmx-1.jpeg',
        },
        {
          src: 'tmx-2.jpeg',
        },
        {
          src: 'tmx-3.jpeg',
        },
        {
          src: 'tmx-4.jpeg',
        },
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>

</style>
